import { z } from 'zod'

export const signInValidation = z.object({
  username: z.string().min(1, 'Username is required'),
  password: z.string().min(8, 'Password must be at least 8 characters long'),
})

export type SignInValidation = z.infer<typeof signInValidation>
